// pc color btns handler
$(() => {
  return;
  let color_elems = document.querySelectorAll(
    ".sug-wrapper .product-option-color .po-img"
  );
  let quick_view_elems = document.querySelectorAll(".quick-add-link");
  // color button
  color_elems.forEach((element) => {
    element.addEventListener("click", pcImageBtnHandler);
  });
  // end cb

  // quick-view button
  quick_view_elems.forEach((qvBtn) => {
    qvBtn.addEventListener("click", quick_view_btn_handler);
  });
  // end qv

  function pcImageBtnHandler(e) {
    let color = e.target.parentElement.dataset.color;
    let the_pc_elem = $(e.target).parents(".handle-pc")[0];
    let the_pId = the_pc_elem.dataset.productId;
    let color_wrappers = $(the_pc_elem).find(".handle-product-img-opt");
    let the_color_wrapper_elem = $(the_pc_elem).find(
      `.handle-product-img-opt[data-color="${color}"]`
    )[0];

    color_wrappers.addClass("hidden");
    $(the_color_wrapper_elem).removeClass("hidden");

    if (color) {
      $("[data-product-selected1]").data(
        "product-selected1",
        `${the_pId}_${color}`
      );
    } else {
      $("[data-product-selected1]").data("product-selected1", the_pId);
    }
  }

  function quick_view_btn_handler(e) {
    e.preventDefault();

    let pc_elem = $(e.target).parents(".handle-pc")[0];
    let handle = pc_elem.dataset.productHandle;
    // let id  = pc_elem.dataset.productId;
    let url = `/products/${handle}?view=quick-view`;
    $.get(url, (response) => {
      $("#handle-response").html(response);
    });
  }
});

// end cb
